import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requiredScreen, requiredRole, requiredPermission, requiredPlatformAdmin }) => {
  const { user, isAuthenticated, isLoading, hasRole, hasPermission, can } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="lis-loading-container">
        <div className="lis-spinner"></div>
        <p>Verifying secure session...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Platform admin check for SaaS Control Center
  if (requiredPlatformAdmin) {
    const isPlatformAdmin = Boolean(
      user?.isPlatformAdmin ||
      user?.tenantId === 1 ||
      ['PLATFORM_ADMIN', 'SUPER_ADMIN', 'SYSTEM_ADMIN'].includes(user?.roleName?.toUpperCase())
    );
    if (!isPlatformAdmin) {
      return <Navigate to="/unauthorized" state={{ reason: 'PLATFORM_ADMIN_REQUIRED' }} replace />;
    }
  }

  // Fine-grained screen permission check
  if (requiredScreen && !can(requiredScreen, 'VIEW')) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Role check fallback
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Legacy permission check fallback
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
